module.exports = __webpack_public_path__ + "img/校车.4a7476ee.png";